import { useAppMutation } from '@/hooks/api';
import { API_ROUTES } from '@/constants/api-routes';
import mutationKeys from '@/constants/mutationKeys';
import { MutateOptions } from 'react-query';

export const useSelectTemplateMutation = (
  templateId: string,
  options?: MutateOptions<
    { envelopeId: string; itemId: number },
    unknown,
    unknown,
    unknown
  >,
) => {
  return useAppMutation<{
    envelopeId: string;
    itemId: number;
  }>({
    routeName: API_ROUTES.SELECT_TEMPLATE_GALLERY_TEMPLATE.replace(
      ':templateId',
      templateId,
    ),
    mutationKey: [mutationKeys.TEMPLATE_GALLERY_SELECT_TEMPLATE],
    method: 'POST',
    options,
  });
};